import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
    PATIENT_VIRTUAL_APPOINTMENTS_KEY,
    VIRTUAL_APPOINTMENTS_OVERVIEW_KEY
} from '../../../../hooks/queryKeys';
import { invalidateCaseDetail } from '../../../work-queue/util';

// Deleting an RDI/SDI cancels its pending VAs server-side, which can also move the case's VA step.
export function useRefreshAfterDocumentDelete(patientId: string): () => void {
    const queryClient = useQueryClient();
    return useCallback(() => {
        void Promise.all([
            queryClient.invalidateQueries({
                queryKey: PATIENT_VIRTUAL_APPOINTMENTS_KEY(patientId)
            }),
            queryClient.invalidateQueries({ queryKey: [VIRTUAL_APPOINTMENTS_OVERVIEW_KEY] }),
            invalidateCaseDetail(queryClient, patientId)
        ]);
    }, [queryClient, patientId]);
}
